import React from "react";
import { STORY_IMAGE } from "@/lib/brand";

export default function Story() {
  return (
    <section
      id="story"
      data-testid="story-section"
      className="py-24 md:py-32 px-6 md:px-12 lg:px-20 bg-[#F5DCD5]"
    >
      <div className="max-w-7xl mx-auto grid lg:grid-cols-12 gap-12 lg:gap-20 items-center">
        <div className="lg:col-span-5 relative">
          <div className="rounded-lg overflow-hidden aspect-[4/5]">
            <img
              src={STORY_IMAGE}
              alt="Hands kneading cookie dough"
              className="w-full h-full object-cover"
              data-testid="story-image"
            />
          </div>
          <div className="absolute -bottom-6 -right-6 hidden md:block bg-white border border-[#EFE8E8] rounded-md px-6 py-4">
            <div className="text-xs uppercase tracking-[0.22em] text-[#B37C7C] mb-1">
              Made in Aubrey, TX
            </div>
            <div className="font-serif-display text-2xl text-[#362C2C]">
              A cozy home bakery
            </div>
          </div>
        </div>

        <div className="lg:col-span-7">
          <div className="text-xs uppercase tracking-[0.22em] text-[#B37C7C] font-medium mb-6">
            Our Story
          </div>
          <h2 className="font-serif-display text-4xl md:text-5xl text-[#362C2C] leading-tight mb-8">
            Made by hand,
            <span className="block italic font-accent-serif text-[#B37C7C]">
              made with love.
            </span>
          </h2>
          <div className="space-y-6 text-[#5C5252] leading-relaxed text-base md:text-lg max-w-xl">
            <p>
              Sweet Rose started in a little kitchen in Aubrey, Texas — just a rolling pin,
              a good vanilla, and the idea that a cookie can make somebody's day. Every
              order is still mixed by hand, cut to your theme, and iced with royal icing
              we tint in small batches.
            </p>
            <p>
              We love turning your ideas into something yummy. Whether it's a birthday,
              a baby shower, a Halloween party, or just because — tell us what you're
              dreaming up and we'll make it happen.
            </p>
          </div>

          <div className="mt-12 grid sm:grid-cols-3 gap-8 border-t border-[#EFE8E8] pt-10">
            {[
              { k: "Real ingredients", v: "Butter, vanilla, and plenty of sprinkles." },
              { k: "Your theme", v: "Custom shapes, colors, and little details." },
              { k: "Hand-iced", v: "Every cookie, one at a time." },
            ].map((item) => (
              <div key={item.k}>
                <div className="font-serif-display text-xl text-[#362C2C] mb-2">
                  {item.k}
                </div>
                <div className="text-sm text-[#5C5252] leading-relaxed">{item.v}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
